import { useEffect } from "react";
import "@/App.css";
import "@/themes.css";
import { BrowserRouter, Routes, Route, useSearchParams, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { LanguageProvider } from "@/i18n";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { TagsProvider } from "@/context/TagsContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AnalyticsTracker } from "@/components/AnalyticsTracker";
import Welcome from "@/pages/Welcome";
import About from "@/pages/About";
import CategoryListing from "@/pages/CategoryListing";
import Lotus from "@/pages/Lotus";
import Deity from "@/pages/Deity";
import DeityDetail from "@/pages/DeityDetail";
import Testimonials from "@/pages/Testimonials";
import Faq from "@/pages/Faq";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import Numerology from "@/pages/Numerology";
import Admin from "@/pages/Admin";

function RefCapture() {
  const [params] = useSearchParams();
  useEffect(() => {
    const ref = params.get("ref");
    if (ref) localStorage.setItem("ciao_ref", ref);
  }, [params]);
  return null;
}

function App() {
  return (
    <ThemeProvider>
    <LanguageProvider>
      <AuthProvider>
        <SettingsProvider>
          <TagsProvider>
          <BrowserRouter>
            <RefCapture />
            <AnalyticsTracker />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Welcome />} />
                <Route path="/about" element={<About />} />
                <Route path="/daily" element={<CategoryListing categories={["daily_merit", "merit_project"]} category="daily_merit" />} />
                <Route path="/projects" element={<Navigate to="/daily" replace />} />
                <Route path="/charity" element={<CategoryListing category="charity" />} />
                <Route path="/shop" element={<CategoryListing category="shop" />} />
                <Route path="/lotus" element={<Lotus />} />
                <Route path="/deity" element={<Deity />} />
                <Route path="/deity/:id" element={<DeityDetail />} />
                <Route path="/testimonials" element={<Testimonials />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/member" element={<Auth />} />
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                <Route path="/numerology" element={<ProtectedRoute><Numerology /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
          </TagsProvider>
        </SettingsProvider>
      </AuthProvider>
    </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
